<template>
  <div class="pageContent">
    <div class="options">
      <el-button type="primary" icon="el-icon-plus" @click="gotoAdd()">添加</el-button>
      <el-radio-group v-model="status" class="options_item" @change="getData">
        <el-radio-button :label="1">进行中</el-radio-button>
        <el-radio-button :label="2">待开始</el-radio-button>
        <el-radio-button :label="3">被取消</el-radio-button>
        <el-radio-button :label="4">已结束</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table_box">
      <el-table :data="tableData" border>
        <el-table-column label="活动名称" prop="name" align="center"></el-table-column>
        <el-table-column label="活动标题" prop="title" align="center"></el-table-column>
        <el-table-column label="活动时间" min-width="200px" prop="show_time" align="center"></el-table-column>
        <!-- <el-table-column label="状态" prop="show_status" align="center"></el-table-column> -->
        <el-table-column label="操作" width="200px" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="downloadItem(scope.row.id)">下载二维码</el-button> -->
            <!-- <el-button type="text" @click="statItem(scope.row.id)">活动统计</el-button>
            <el-button type="text" @click="sendItem(scope.row.id)">发送通知</el-button> -->
            <el-button type="text" @click="qrcodeItem(scope.row.id)">活动二维码</el-button>
            <el-button type="text" @click="showItem(scope.row.id)">查看</el-button>
            <el-button type="text" v-if="status == 1 || status == 2" @click="cancelItem(scope.row.id)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showDetail" title="活动设置" width="1000px" @close="closeDetail">
      <div v-loading="dialogLoading">
        <detail :step="detailStep" :fromPage="'list'"></detail>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showQrcode" title="活动二维码" @close="closeQrcode" width="300px">
      <div v-loading="qrcodeLoading" style="text-align:center">
        <img class="qrcode_box" :src="qrcodeFrom.qrcode" alt="">
        <div style="margin-top: 25px">
          <el-button type="primary" @click="downloadQrcode">下载二维码</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import detail from "./form3"
import { getInviteList,getInviteConfig,cancelInvite,inviteQrcode } from "@/api/market"
export default {
  computed: {
    ...mapGetters(["token", "app_id", "inviteForm"])
  },
  components: {
    detail
  },
  data(){
    return{
      tableData: [], // 表格数据
      page: 1, // 页码
      total: 0, // 总数
      sendContent: "", //发送通知内容
      showDetail: false,
      dialogLoading: false, // 弹窗loading
      detailStep: 0,
      status: 1, 
      statusList: [
        {id: 1, name: "进行中"},
        {id: 2, name: "待开始"},
        {id: 3, name: "已取消"},
        {id: 4, name: "已结束"}
      ],
      showQrcode: false, // 活动二维码弹窗
      qrcodeFrom: {
        qrcode: ""
      }, // 二维码内容
      qrcodeLoading: false,
      item_id: "", // 下载二维码
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(){
      var data = {
        page: this.page,
        status: this.status,
        app_id: this.app_id
      }
      getInviteList(data).then(res => {
        if(res.code == 200){
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.tableData.forEach(item => {
            item.show_time = this.mydateFormat(item.start_time) + " ~ " + this.mydateFormat(item.end_time);
            // item.show_status = this.statusList.find(x => x.id == item.status).name;
          })
        }else{
          this.$message(res.msg)
        }
      })
    },
    cancelItem(id){
      console.log(id)
      var data = {
        app_id: this.app_id,
        id: id
      }
      this.$confirm("确定取消？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelInvite(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "取消成功"
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      })
      .catch();
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
    gotoAdd(){
      this.$router.push("/apply/newVip/13/market/marketing/client/invite/invite")
    },
    downloadItem(id){ // 下载二维码

    },
    statItem(id) { // 活动统计
      console.log(id)
    },
    sendItem(id) { // 发送通知
      this.showSend = true;
    },
    cancelSend(){
      this.showSend = false;
      this.sendContent = "";
    },
    closeDetail(){
      this.showDetail = false;
      this.detailStep = 0
    },
    showItem(id){
      this.showDetail = true;
      this.dialogLoading = true;
      getInviteConfig({app_id:this.app_id,id:id}).then(res => {
        if(res.code == 200){
          this.$store.commit("SET_INVITEFORM",res.data);
          console.log(this.inviteForm)
          this.dialogLoading = false;
          this.detailStep = 3;
        }
      })
    },
    qrcodeItem(id){
      this.item_id = id;
      this.showQrcode = true;
      this.qrcodeLoading = true;
      var data = {
        app_id: this.app_id,
        id: id
      }
      inviteQrcode(data).then(res => {
        if(res.code == 200){
          this.qrcodeFrom = res.data;
        }else{
          this.$message(res.msg);
        }
        this.qrcodeLoading = false;
      })
    },
    closeQrcode(){
      this.showQrcode = false;
      this.qrcodeFrom = {
        qrcode: ""
      }
    },
    downloadQrcode(){
      var linkUrl = localStorage.getItem('baseStatus') == 'test'? "https://cs.58zltc.com/":"https://www.58zltc.com/";
      linkUrl += "manage/activity.invite/downLoadInvite" + 
        "?token=" + this.token +
        "&app_id=" + this.app_id +
        "&id=" + this.item_id;
      window.location.href = linkUrl;
    },
  },
}
</script>

<style lang="scss" scoped>
.pageContent{
  padding-top: 20px;
  .options{
    margin-bottom: 20px;
  }
  .table_box{
    margin-bottom: 10px;
  }
}
.form_bottom_btn{
  margin-top: 50px;
  text-align: center;
}
.options_item{
  margin-left: 26px;
  vertical-align: top;
}
.qrcode_box{
  width: 180px;
  height: 180px;
  margin: 0 auto;
}
</style>